import type { ChartPeriod } from '@/types/periods'
import { cn } from '@/utils/cn'
import { Button } from '../common/button'
import { Popover, PopoverContent, PopoverList, PopoverListItem, PopoverTrigger } from '../common/popover'
import { ArrowIcon } from '../icons/arrow'

interface ChartRangeSelectorProps {
  chartPeriods: ChartPeriod[]
  chartsPeriod: ChartPeriod
  onRangeSelect: (chartsPeriod: ChartPeriod) => void
  prefix?: string
  className?: string
}

export const ChartRangeSelector = ({
  chartPeriods,
  chartsPeriod,
  onRangeSelect,
  prefix,
  className,
}: ChartRangeSelectorProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="input"
          size="sm"
          className={cn('group min-w-20 justify-end gap-1 bg-page pr-1 pl-3', className)}
        >
          {prefix} {chartsPeriod}D
          <div className="group-data-[state=open]:-scale-y-100 transition-transform">
            <ArrowIcon direction="down" size={20} />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverList>
          {chartPeriods.map((period) => (
            <PopoverListItem key={period} className="border-t">
              <Button
                variant="default"
                onClick={() => {
                  onRangeSelect(period)
                }}
                className="px-4"
              >
                {period}D
              </Button>
            </PopoverListItem>
          ))}
        </PopoverList>
      </PopoverContent>
    </Popover>
  )
}
